// extracted by mini-css-extract-plugin
module.exports = {"Homepage__testimonials":"Homepage_Homepage__testimonials__btrGx"};